module.exports = __webpack_public_path__ + "images/burst-left.gif";